import React from 'react';
import { motion } from 'framer-motion';
export function PartnersSection() {
  const aliados = [{
    name: 'Zumpago',
    role: 'Aliado Estratégico',
    color: 'border-brand-royal',
    logo: 'https://cdn.magicpatterns.com/uploads/iNzdawee4YjikvKe5nhXUb/zumpago.png'
  }, {
    name: 'IPSE',
    role: 'Aliado Estratégico',
    color: 'border-brand-crimson',
    logo: 'https://cdn.magicpatterns.com/uploads/atcuPiiSNdJjNuWTVmy4PZ/Logo_Ipse.jpg'
  }, {
    name: 'TicketMaestro',
    role: 'Aliado Estratégico',
    color: 'border-brand-gold',
    logo: 'https://cdn.magicpatterns.com/uploads/jKD8atXbseAyz3n4yhMyR6/logo_ticketmaestro_positivo.png'
  }, {
    name: 'QuickCont',
    role: 'Aliado Estratégico',
    color: 'border-brand-lightBlue',
    logo: 'https://cdn.magicpatterns.com/uploads/7HATQSBk7ayiTh7seJHvax/Quickcont_-_Logo_Fondo_Blanco_Cuadrado.jpg'
  }];
  return <section id="aliados" className="py-24 bg-white" data-id="element-612">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-613">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6" data-id="element-614">
          <div className="max-w-2xl" data-id="element-615">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="text-brand-royal font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-616">
              Nuestra Red
            </motion.h2>
            <motion.h3 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-4xl md:text-5xl font-heading font-bold text-brand-navy" data-id="element-617">
              Empresas que hacen la diferencia
            </motion.h3>
          </div>
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-618">
            <p className="text-gray-600 max-w-md md:text-right" data-id="element-619">
              Gracias al compromiso de estas organizaciones, podemos extender
              nuestro alcance y multiplicar el impacto en todo el país.
            </p>
          </motion.div>
        </div>

        {/* Aliados Estratégicos */}
        <motion.h4 initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-lg font-heading font-semibold text-brand-royal uppercase tracking-wider mb-6" data-id="element-620">
          Aliados Estratégicos
        </motion.h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-621">
          {aliados.map((partner, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1,
          duration: 0.4
        }} className={`bg-gray-50 rounded-2xl p-8 flex flex-col items-center justify-center text-center h-48 border-b-4 ${partner.color} hover:bg-white hover:shadow-lg transition-all duration-300 group cursor-default`} data-id="element-622">
              {partner.logo ? <img src={partner.logo} alt={`Logo ${partner.name}`} className="h-14 w-auto object-contain mb-3 group-hover:scale-105 transition-transform" data-id="element-623" /> : <h4 className="text-2xl font-heading font-bold text-brand-navy mb-2 group-hover:scale-105 transition-transform" data-id="element-624">
                  {partner.name}
                </h4>}
              <span className="text-sm text-gray-500 font-medium uppercase tracking-wider" data-id="element-625">
                {partner.role}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}